/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Cell } from "react-table";
import { dateFormat } from "~/constants";

type Row = {
  createdAt: string;
};

export const EventsListColumns = [
  {
    Header: "Created At",
    accessor: "createdAt",
    disableSortBy: true,
    width: "3%",
    Cell: ({ row }: Cell<Row>) => (
      <div> {dayjs(row.original.createdAt).format(dateFormat.fullDate)}</div>
    ),
  },
  {
    Header: "Title",
    accessor: "title",
    width: "3%",
    disableSortBy: true,
  },
  {
    Header: "type",
    accessor: "type",
    width: "3%",
    disableSortBy: true,
  },
  {
    Header: "Content",
    accessor: "content",
    disableSortBy: true,
    width: "3%",
  },
];
